import { Auth } from '../src/api/Auth';
import { ContentManager } from "../src/helpers/ContentManager";
import { Api } from "../src/api/Api";
import { GetDataHelper } from "../src/helpers/GetDataHelper";
import {initInterface} from "../src/initInterface";
import {setAuthRegButtonListeners} from "../src/listners/setAuthRegButtonListeners";
import {initGlobalStore} from "../src/store";
import {setReviewFormListener} from "../src/listners/setReviewFormListener";
import {resolveTopBar} from "../src/functions/resolveTopBar";
import {setCateringFormListener} from "../src/listners/setCateringFormListener";

window.content = new ContentManager();
window.auth = new Auth();
window.DataHelper = new GetDataHelper();
window.api = new Api();


// initInterface(); // jquery legacy
initGlobalStore();

setAuthRegButtonListeners(setPage);
setReviewFormListener();

function main() {
    Promise.all([api.getUserProfile(), api.getUsersBonusBalance()]).then(() => {
        content.setProfileHeader(DataHelper.store.user, DataHelper.store.bonuses);
        content.hideModalWindows(false);
    })
      .catch(error => console.log("error on auth check: ", error))
      .finally(setPage);
}

function setPage() {
    resolveTopBar().then(() => {
        setCateringFormListener("#catering-form");
    })
}

main();
